import { get, isEmpty } from "lodash";

import type { ClientConfig, ValidationConfig } from "@platform/dmv-api";

import SettingsSection from "./SettingsSection";

const ValidationSection = ({
  id,
  config,
}: {
  id?: string;
  config: ClientConfig | null;
}) => {
  const enabled = get(config, "validationConfig.enabled", false);
  const rules: NonNullable<ValidationConfig["rules"]> = get(
    config,
    "validationConfig.rules",
    []
  );

  if (!enabled) {
    return null;
  }

  return (
    <SettingsSection
      id={id}
      title="Validation"
      subtitle={
        <>
          Evaluate a set of rules against a policy to determine if your
          application's requirements are met.{" "}
          <a
            href="https://docs.axle.insure/guides/validate/policy-validation"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Learn more
          </a>
        </>
      }
    >
      {isEmpty(rules) ? (
        <p className="text-sm text-gray-500">No validation rules configured.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 text-left">
                <th className="pb-3 font-medium text-gray-700">Rule</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {rules.map((item, index) => (
                <tr key={index}>
                  <td className="py-3">
                    <code className="text-xs bg-gray-100 px-1.5 py-0.5 rounded">
                      {item.rule}
                    </code>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SettingsSection>
  );
};

export default ValidationSection;
